export const FormFieldNames = {
	LegalEntityID: "Legal Entity ID",
};
